var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { display: "flex", "flex-direction": "column" } },
    [
      _c(
        "cargo-advance-select",
        _vm._b(
          {
            attrs: {
              "select-type": _vm.TYPE_NAMES.basic_data_CargoInformation,
              "default-value": _vm.job.cargoCode
            },
            on: { parentCallBack: _vm.onParentCallBack }
          },
          "cargo-advance-select",
          _vm.$attrs,
          false
        )
      ),
      _c("el-input", {
        attrs: { disabled: _vm.disabled || !_vm.job.cargoCode },
        on: {
          change: function($event) {
            return _vm.onChange("cargoName")
          }
        },
        model: {
          value: _vm.job.cargoName,
          callback: function($$v) {
            _vm.$set(_vm.job, "cargoName", $$v)
          },
          expression: "job.cargoName"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }